import { motion, useMotionValue, useTransform, animate, useSpring, useInView } from 'framer-motion';
import React, { useEffect, useState, useRef } from 'react';

function AnimatedNumber({ value }) {
    let spring = useSpring(value, { mass: 1, stiffness: 40, damping: 12 }); //0.8 , 25 , 15 default values
    let display = useTransform(spring, (current) => {
        return Number.isInteger(value) ? Math.round(current) : current.toFixed(1);
    }
    );
  
    useEffect(() => {
      spring.set(value);
    }, [spring, value]);
  
    return <motion.span>{display}</motion.span>;
}

  function CounterCard({ number, symbol, is_num, text, index }) {
    const ref = useRef();
    const isInView = useInView(ref, { once: true, margin: '0px 0px -100px 0px' });
    const [value, setValue] = useState(is_num ? 0 : number); // Initialize value correctly

    useEffect(() => {
        if (isInView && is_num) {
            setValue(number); // Update value only once when the component mounts
        }
    }, [isInView, is_num, number]);

    return (
        <article className={`counter_card ${index > 0 ? 'md:border-l md:border-zuriq-border dark:md:border-zuriq-border_dark' : ''}`} ref={ref}>
            <div className="inline-block w-min">
                <div className="flex flex-col items-center">
                    <span>
                        {is_num ? (
                            <AnimatedNumber value={value} />
                        ) : (
                            <span>{value}</span>
                        )}
                        {symbol}
                    </span>
                    <p>{text}</p>
                </div>
            </div>
        </article>
    );
}

function CounterApp({ counter_data }) {
    return (
        <>
            {counter_data.map((item, index) => (
                <CounterCard 
                    key={index} 
                    number={item.number} 
                    symbol={item.symbol} 
                    is_num={item.is_num} 
                    text={item.text} 
                    index={index}
                />
            ))}
        </>
    );
}

export default CounterApp;